import React, { useEffect, useState, useContext } from 'react';
import globals from '../../Services/globals.js';
import loginService from '../../Services/loginService.js';
import avatar from '../../img/avatar.svg';
import helper from '../../Services/helper.js';
import apiService from '../../Services/apiServices.js';
import UserPermissionContext from '../../components/Context/UserPermissionContext.js';

const Header = () => {
  const [user, setUser] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [settings, setSettings] = useState({});
  const [roleId, setRoleId] = useState(2);
  const [userPermissions, setUserPermissions] = useState([]);
  const { userPermission } = useContext(UserPermissionContext);

  const gl = new globals();
  const loginSrv = new loginService();

  useEffect(() => {
    const loggedUser = gl.getLogedInUser();
    if (!loggedUser) return;

    const company = loggedUser.company;
    const userData = loggedUser?.data;

    if (userData) {
      setUser(`${userData.firstname} ${userData.lastname}`);
      setCompanyName(company);
    }

    getUserSettings();
    const settingsInterval = setInterval(getUserSettings, 1000);

    getRole();
    getPermissions();

    return () => clearInterval(settingsInterval);
  }, []);

  useEffect(() => {
    if (window.location.hash === '#/settingsTrue') {
      getSettings();
    }
  });

  const getUserSettings = () => {
    gl.getUserSettings().then(sett => {
      if (sett) {
        setSettings(sett);
      }
    });
  };

  const getSettings = () => {
    apiService().get('settings').then(response => {
      if (response.success) {
        const sett = response.data[0];
        setCompanyName(sett.companyName);
      } else {
        console.log('Error:' + response.errorMessage);
      }
    });
  };

  const getRole = () => {
    const logedInUser = gl.getLogedInUser();
    apiService()
      .query('userRoles', 'username=' + logedInUser?.data?.username)
      .then(response => {
        if (response.success && response.data?.length > 0) {
          setRoleId(response.data[0].roleId);
        }
      });
  };

  const getPermissions = () => {
    const params = `&username=${gl.getLogedInUser().data?.username}`;
    apiService()
      .query('getUserPermissions', params)
      .then(response => {
        if (response.success) {
          setUserPermissions(response.data);
        }
      });
  };

  const logout = () => {
    loginSrv.logout();
  };

  return (
    <nav
      id="navi"
      style={{ background: settings?.style || '#5a5c69' }}
      className="navbar navbar-expand navbar-light col-md-12 topbar static-top position-fixed px-1 px-md-3"
    >
      <div className="col-lg-2">
        <div
          className="btn-group companyNameDashBoard shadow-none"
          style={{ background: settings?.style || '#5a5c69' }}
        >
          <button type="button" className="btn shadow-sm bg-body-tertiary rounded">
            <a href="#/">{companyName.substring(0, 25)}</a>
          </button>
          <button
            type="button"
            className="btn shadow-sm bg-body-tertiary rounded dropdown-toggle dropdown-toggle-split"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span className="sr-only">Toggle Dropdown</span>
          </button>
          <div className="dropdown-menu" style={{ background: settings?.style || '#5a5c69' }}>
            <button
              type="button"
              className="px-0 border border-0 w-100"
              style={{ background: settings?.style || '#5a5c69' }}
            >
              <a href="#/selectcompany">{helper().translate('CHANGE_COMPANY')}</a>
            </button>
          </div>
        </div>
      </div>

      <ul className="col-lg-8 top-menu d-md-flex justify-content-center text-center mb-0 overflow-auto overflow-md-auto">
        <li className="px-2 px-md-3">
          <a href="#/">{helper().translate('DASHBOARD')}</a>
        </li>
        {userPermission?.find(f => f.moduleName === 'ITEMS')?.allowView ?
          <li className="px-2 px-md-3">
            <a href="#/registration">{helper().translate('REGISTRATIONS')}</a>
          </li> : ""
        }
        {userPermission?.find(f => f.moduleName === 'FINANCE')?.allowView ?
          <li className="px-2 px-md-3">
            <a href="#/finances">{helper().translate('FINANCE')}</a>
          </li> : ""
        }
        {roleId === 1 && (
          <>
            <li className="px-2 px-md-3">
              <a href="#/administration">{helper().translate('ADMINISTRATION')}</a>
            </li>
            <li className="px-2 px-md-3">
              <a href="#/settings">{helper().translate('SETTINGS')}</a>
            </li>
          </>
        )}
        <li className="px-2 px-md-3">
          <a href="#/features">{helper().translate('OTHER')}</a>
        </li>
      </ul>

      <ul className="col-lg-2 navbar-nav d-flex flex-row-reverse">
        <li className="nav-item dropdown no-arrow">
          <span
            className="nav-link dropdown-toggle px-1 px-md-3"
            id="userDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span className="mr-2 d-none d-lg-inline small">{user}</span>
            <a href="#">
              <img className="img-profile rounded-circle" src={avatar} alt="avatar" />
            </a>
          </span>
          <div
            className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
            aria-labelledby="userDropdown"
          >
            <a className="dropdown-item" href={roleId !== 10 ? '#/user-profile' : ''}>
              <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400" />
              Profile
            </a>
            <a className="dropdown-item" href="#/settings">
              <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400" />
              Settings
            </a>
            <a className="dropdown-item" href="#">
              <i className="fas fa-list fa-sm fa-fw mr-2 text-gray-400" />
              Activity Log
            </a>
            <div className="dropdown-divider" />
            <button className="dropdown-item" onClick={logout}>
              <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
              Logout
            </button>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default Header;
